import React from 'react'
import '../styles/chart.css'
import Chart from 'react-apexcharts';

class LineChart extends React.Component {
  constructor(props) {
    super(props);
    let seriesArray = this.createSeriesArray(props.buyinsList)
    const mostBuyinsArray = this.createMostBuyinsArray(seriesArray);
    this.state = {
      options: {
        colors: ['#008FFB', '#00E396', '#FEB019', '#FF4560', '#775DD0', '#3F51B5', '#546E7A', '#D4526E', '#8D5B4C', '#F86624'],

        chart: {
          type: 'line',
        },
        xaxis: {
          categories: mostBuyinsArray, // Will be filled with HH:MM time format
        },
        yaxis: {
        },
      },
      series: seriesArray,
    };
  }

  // Method to convert time to HH:MM format
  convertTimeToHHMM = (time) => {
    const [hours, minutes] = time.split(':');
    return `${hours}:${minutes}`;
  }



  createSeriesArray(buyinsList) {
    let tempSeriesArray = []
    let tempSeriesObj = {}
    buyinsList.forEach(buyin => {
      if (!tempSeriesObj[buyin.playerName]) {
        tempSeriesObj[buyin.playerName] = [];
        // tempSeriesObj[buyin.playerName].unshift(0);
      }
      tempSeriesObj[buyin.playerName].unshift(buyin.totalBuyinAmount);
    })

    for (let key in tempSeriesObj) {
      let tempObj = {}
      tempObj['name'] = key;
      tempObj['data'] = tempSeriesObj[key]
      tempObj['data'].unshift(0);
      tempSeriesArray.push(tempObj);
    }
    const sortedTempSeriesArray = tempSeriesArray.sort((a,b)=>a.name.localeCompare(b.name))
    return sortedTempSeriesArray;
  }

  createMostBuyinsArray(buyinsArray) {
    let mostBuyins = 0
    buyinsArray.forEach(playerBuyin => {
      mostBuyins = Math.max(playerBuyin['data'].length, mostBuyins)
    })

    return Array.from({ length: mostBuyins }, (_, i) => i)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.buyinsList !== this.props.buyinsList) {
      const { buyinsList } = this.props;
      const seriesArray = this.createSeriesArray(buyinsList)
      const mostBuyinsArray = this.createMostBuyinsArray(seriesArray);
      console.log(mostBuyinsArray)
      // Update state with new data
      this.setState({
        options: {
          ...this.state.options,
          xaxis: {
            categories: mostBuyinsArray,
          },
        },
        series: seriesArray,
      });
    }
  }


  render() {
    return (
      <div className='chartContainer'>
        <h2 className='title'>סך כל הפריטות</h2>
        <div className="chart">
          <Chart options={this.state.options} series={this.state.series} type="line" height="300px" />
        </div>
      </div>
    );
  }
}

export default LineChart;
